import React, { useMemo } from 'react';
import classNames from 'classnames';
import AgreementPdfViewer from 'components/AgreementPdfViewer';
import { AgreementField } from 'models/Agreement';
import AgreementFieldsPreviewContext from './AgreementFieldsPreview.context';
import ReadOnlyFieldsLayer from './components/ReadOnlyFieldsLayer';

import './AgreementFieldsPreview.styles.scss';

type AgreementFieldsPreviewProps = {
  className?: string;
  fileUrl: string;
  fields: AgreementField[];
};

const AgreementFieldsPreview: React.FC<AgreementFieldsPreviewProps> = (
  props,
) => {
  const { className, fileUrl, fields } = props;

  const classes = classNames('agreement-fields-preview', className);

  const value = useMemo(() => ({ fields }), [fields]);

  return (
    <AgreementFieldsPreviewContext.Provider value={value}>
      <AgreementPdfViewer
        className={classes}
        fileUrl={fileUrl}
        PageLayer={ReadOnlyFieldsLayer}
      />
    </AgreementFieldsPreviewContext.Provider>
  );
};

export default AgreementFieldsPreview;
